import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Direction } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { PopUpComponent } from '../pop-up.component';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import {
  CLOSE,
  SITE_INTRO_TITLE,
  SITE_INTRO_DESCRIPTION,
  SITE_INTRO_MORE_INFO,
  SITE_INTRO_CLOSE,
  SITE_INTRO_DONT_SHOW_AGAIN,
  SITE_INTRO_DESCRIPTION_2,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-site-intro-pop-up',
  templateUrl: './site-intro-pop-up.component.html',
  styleUrls: ['./site-intro-pop-up.component.scss'],
  standalone: false,
})
export class SiteIntroPopUpComponent extends PopUpComponent implements OnInit {
  static readonly STORAGE_KEY = 'siteIntroDismissed';

  direction: Direction;
  titleText: string;
  descriptionText: string;
  descriptionText2: string;
  moreInfoText: string;
  closeButtonText: string;
  dontShowAgainText: string;
  closeXLabel: string;
  safeVideoUrl: SafeResourceUrl;
  isEmbedVideo: boolean;

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,
    @Inject(POPUP_DATA)
    public readonly data: { videoUrl: string; moreInfoUrl: string },
    private readonly languageService: LanguageService,
    private readonly localStorageService: LocalStorageService,
    private readonly sanitizer: DomSanitizer
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.isEmbedVideo = environment.isEmbedVideo;
    if (this.isEmbedVideo) {
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.videoUrl);
    }
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts(): void {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.titleText = SITE_INTRO_TITLE[language.language];
      this.descriptionText = SITE_INTRO_DESCRIPTION[language.language];
      this.descriptionText2 = SITE_INTRO_DESCRIPTION_2[language.language];
      this.moreInfoText = SITE_INTRO_MORE_INFO[language.language];
      this.closeButtonText = SITE_INTRO_CLOSE[language.language];
      this.dontShowAgainText = SITE_INTRO_DONT_SHOW_AGAIN[language.language];
      this.closeXLabel = CLOSE[language.language];
    });
  }

  openMoreInfo(): void {
    window.open(this.data.moreInfoUrl, '_blank');
  }

  close(): void {
    this.closeCard();
  }

  closeAndDontShowAgain(): void {
    this.localStorageService.setItem(SiteIntroPopUpComponent.STORAGE_KEY, true);
    this.closeCard();
  }
}
